export class Document {
  documentId
  applicationId
  type
  status
  name
  size
  mimetype
  documentURL
  timestamp

  constructor(document = {}) {
    this.documentId = document.documentId ? String(document.documentId) : ''
    this.applicationId = document.applicationId ? String(document.applicationId) : ''
    this.type = document.type ? String(document.type) : ''
    this.status = document.status ? String(document.status) : ''
    this.name = document.name ? String(document.name) : ''
    this.size = document.size ? Number(document.size) : 0
    this.mimetype = document.mimetype ? String(document.mimetype) : ''
    this.documentURL = document.documentURL ? String(document.documentURL) : ''
    this.timestamp = document.timestamp ? new Date(document.timestamp) : new Date()
  }
}